import { setErrorStatus } from "../Redux/status/action";
import { throwError } from "./error";

export async function checkAccountAvailability(phoneNumber) {
  const response = await fetch(
    `${
      process.env.REACT_APP_BASE_URL
    }/profile/isExists?phoneNumber=${encodeURIComponent(phoneNumber)}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    }
  );
  const result = await response.json();
  if (result.error) {
    handleError(result.error, "checkAccountAvailability");
  }
  return result;
}

export async function compareFace(locationData, accessToken) {
  const response = await fetch(
    `https://asia-south1-${process.env.REACT_APP_PROJECT_ID}.cloudfunctions.net/faceComparison/compare`,
    {
      method: "POST",
      headers: {
        Accept: "*/*",
        "x-auth-token": `Bearer ${accessToken}`
      },
      body: locationData
    }
  );
  const result = await response.json();
  if (result.error) {
    handleError(result.error, "compareFace");
  }
  return result;
}

function handleError(error, errorFrom) {
  if (error.name === "requestError") {
    setErrorStatus({ code: "custom", message: error.message });
  } else if (error.name === "authError") {
    setErrorStatus(
      {
        code: "auth/id-token-expired",
        message: "Session expired. Please login"
      },
      errorFrom
    );
  } else {
    throw error;
  }
}

// The API error envelope identifies its kind via `name`, but errorHandler
// switches on `code`. requestError messages are written for the employee, so
// map them onto code "custom", which errorHandler surfaces verbatim.
// Anything else is passed through untouched and falls back to the generic message.
function toCodedError(error) {
  if (error?.name === "requestError") {
    return throwError("custom", error.message);
  }
  return error;
}

export async function createComplaint(data, accessToken) {
  const response = await fetch(`${process.env.REACT_APP_BASE_URL}/complaint`, {
    method: "POST",
    headers: {
      Accept: "*/*",
      "x-auth-token": `Bearer ${accessToken}`
    },
    body: data
  });
  const result = await response.json();
  if (result.error) {
    throw toCodedError(result.error);
  }
  return result;
}

export async function updateComplaint(data, accessToken) {
  const response = await fetch(`${process.env.REACT_APP_BASE_URL}/complaint`, {
    method: "PATCH",
    headers: {
      Accept: "*/*",
      "x-auth-token": `Bearer ${accessToken}`
    },
    body: data
  });
  const result = await response.json();
  if (result.error) {
    throw toCodedError(result.error);
  }
  return result;
}

export async function createProcedureHistory(data, accessToken) {
  const response = await fetch(
    `${process.env.REACT_APP_BASE_URL}/procedureHistory`,
    {
      method: "POST",
      headers: {
        Accept: "*/*",
        "x-auth-token": `Bearer ${accessToken}`
      },
      body: data
    }
  );
  const result = await response.json();
  if (result.error) {
    throw toCodedError(result.error);
  }
  return result;
}
